// test1849
(1849 && 0);
